import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import { get, includes, uniqBy, sortBy } from 'lodash';
import { push } from 'connected-react-router';
import compose from 'recompose/compose';
import { Button, withStyles } from '@material-ui/core';
import { getI18n } from '../../../../utils/intl';
import { useIntl } from 'react-intl';
import { array, arrayOf, bool, func, object, string } from 'prop-types';

import {
  AlertDialog,
  AlertMessages, Footer, FormTextField,
} from '../../../../components';
import {
  fetchListDetails,
  fetchRequestDetails,
  submitRequest,
  reviewApplication,
  withdrawRequest,
} from '../../../../actions/requests';
import {
  getAppReviewUpdateStatus,
  getErrors,
  getDetailsListResults,
  getRequestDetails,
  getRequestUpdateStatus,
  getAppReviewResponse,
  getAppWithdrawStatus,
} from '../../../../reducers/request';
import { getFeatureFlagApiPlans } from '../../../../reducers/portalConfig';
import styles from './styles';
import { RequestSectionTable, ApisTable } from './SectionTable';
import { buildDetailsData, buildEditRequestTable, buildEditApisRequestTable,
  buildSingleApplicationRequestMap, getTableColumns, getTableApisColumns } from './utils';
import { ALERT_SUCCESS, SUCCESS, ALERT_ERROR, FAIL, getOrgBoundRoles } from '../../../../constants';
import { getUserDetails } from '../../../../reducers/portalConfig';
export const Requests = (props) => {
  const {
    classes,
    listResults,
    requestDetails,
    requestUpdateStatus,
    appReviewUpdateStatus,
    errors,
    applicationUuid,
    apiPlansEnabled,
    appReviewResponse,
    isCurrentTab,
    isAdmin,
    appWithdrawStatus,
  } = props;

  const orderList = ["registration", "status", "addinfo", "details", "drydetails",
               "customfields", "apis", "apiplans", "apigroups", "apikeys"];
  const [notificationMessage, setNotificationMessage] = useState(localStorage.getItem('notificationMessage'));
  const [notificationStatus, setNotificationStatus] = useState(localStorage.getItem('notificationStatus'));
  const [requestDetailsMap, setRequestDetailsMap] = useState({});
  const [requestType, setRequestType] = useState('');
  const [reviewRequestType, setReviewRequestType] = useState('');
  const [apisRequestDetails, setApisRequestDetails] = useState([]);
  const [requestDetailsCount, setRequestDetailsCount] = useState(0);
  const [requestInfoMap, setRequestInfoMap] = useState({});
  const [singleRequest, setSingleRequest] = useState(false);
  const [showActionAlert, setShowActionAlert] = useState(false);
  const [actionType, setActionType] = useState('');
  const [uuidType, setUuidType] = useState('');
  const [actionUuid, setActionUuid] =useState('');
  const [actionTable, setActionTable] = useState('');
  const [pendingRequestCount, setPendingRequestCount] = useState(-1);
  const [actionTableMap, setActionTableMap] = useState({});
  const [alertReason, setAlertReason] = useState('');
  const [detailsRequestExist, setDetailsRequestExist] = useState(true);
  const [singleRequestUuid, setSingleRequestUuid] = useState('');
  const intl = getI18n(useIntl());
  const [assignedOrg, setAssignedOrg] = useState({ uuid : '', name : '' });
  const [assignedOrgSearchText, setAssignedOrgSearchText] = useState('');
  const assignRoleOptions = getOrgBoundRoles(intl);
  const [assignedRole, setAssignedRole] = useState(assignRoleOptions[0].uuid);
  const [shouldNotifyUser, setShouldNotifyUser] = useState(false);
  const [hasRequests, setHasRequests] = useState(true);
  const { getI18nMessage } = intl;
  const entityUuid = applicationUuid;

  useEffect(()=> {
    if(isCurrentTab) {
      props.fetchListDetails({ entityUuid: applicationUuid });
      notifyMessages('','');
    }
  },[applicationUuid, isCurrentTab]);
  useEffect(() => {
    if(listResults) {
      if(listResults.length > 0) {
        setHasRequests(true);
        const firstRequest = listResults[0];
        const reqType = get(firstRequest, 'requestType');
        const reqSubtype = get(firstRequest, 'requestSubtype');
        const reqSubType = get(firstRequest, 'requestSubtype');
        if(reqType === 'APPLICATION' ||
          (reqType === 'APPLICATION_DETAILS' && reqSubType === 'APP_STATUS_CHANGE'))
        {
          setSingleRequest(true);
          setRequestType(reqSubtype === 'DELETE' || reqSubtype === 'UPDATE'? `APPLICATION_${reqSubType}` : reqType);
          setSingleRequestUuid(firstRequest.uuid);
        } else {
          setDetailsRequestExist(listResults.find(req => req.requestType === 'APPLICATION_DETAILS'));
          setRequestType('APPLICATION_EDIT');
        }
        setPendingRequestCount(listResults.length);
        if(reqType !== 'REGISTRATION') {
          listResults.map(req => props.fetchRequestDetails(req.uuid));
        }
      } else {
        setHasRequests(false);
      }
    }
  },[listResults]);
  useEffect(() => {
    if(requestDetails && requestDetails.request) {
      setRequestDetailsCount(requestDetailsCount+1);
      const reqType=requestDetails.request.requestType;
      if(reqType === 'APPLICATION') {
        setRequestDetailsMap(buildSingleApplicationRequestMap(classes, requestDetails));
      } else {
        //Added for apis and apisPlans
        if(reqType === "PATCH_APPLICATION_API_PLANS" || reqType === "PATCH_APPLICATION_APIS") {
          const obj = apisRequestDetails;
          obj.push(requestDetails);
          setApisRequestDetails(obj);
        } else {
          const { type, dataTable } = buildEditRequestTable(classes, requestDetails);
          if(requestDetails.request.requestSubtype === 'APP_STATUS_CHANGE') {
            setRequestDetailsMap({
              ...requestDetailsMap,
              [type]: dataTable,
              ['addinfo'] : buildDetailsData(classes, requestDetails.original.applicationDetails, null, true),
            });
          } else {
            if(!requestDetailsMap['details'] && !detailsRequestExist) {
              setRequestDetailsMap({
                ...requestDetailsMap,
                [type]: dataTable,
                drydetails:
                  buildDetailsData(classes, requestDetails.applicationExcerpt, null, false),
              });
            } else {
              setRequestDetailsMap({
                ...requestDetailsMap,
                [type]: dataTable,
              });
            }
          }
          setRequestInfoMap({
            ...requestInfoMap,
            [type]: requestDetails.request,
          });
        }
      }
    }
  }, [requestDetails]);
  useEffect(() => {
    if(listResults && requestDetailsCount === listResults.length
        && apisRequestDetails.length > 0 && !singleRequest) {
      const { type, dataTable } = buildEditApisRequestTable(apisRequestDetails, apiPlansEnabled);
      let apisTable = uniqBy(dataTable, 'uuid');
      apisTable = sortBy(apisTable, 'modifyTs').reverse();
      //Added code for app requestDetails.request.requestSubtype === 'APP_STATUS_CHANGE'
      if(!requestDetailsMap['details'] && !detailsRequestExist) {
        setRequestDetailsMap({
          ...requestDetailsMap,
          [type]: apisTable,
          drydetails:
            buildDetailsData(classes, apisRequestDetails[0].applicationExcerpt, null, false),
        });
      } else {
        setRequestDetailsMap({
          ...requestDetailsMap,
          [type]: apisTable,
        });
      }
    }
  },[requestDetailsCount, listResults, apisRequestDetails, requestDetails])
  useEffect(() => {
    if(requestUpdateStatus) {
      setShowActionAlert(false);
      setAlertReason('');
      if(singleRequest) {
        if(requestUpdateStatus === SUCCESS) {
          const message=intl.getI18nMessage(`label.application.details.section.${actionType}.success`);
          localStorage.setItem('notificationStatusRequestSaveSuccess', ALERT_SUCCESS);
          localStorage.setItem('notificationMessageRequestSaveSuccess', message);
          notifyMessages(message, ALERT_SUCCESS);
          window.location.reload();
        } else if (requestUpdateStatus === FAIL){
          let errorMsg = intl.getI18nMessage(`label.application.details.section.${actionType}.error`);
          if(errors && errors.length > 0 && errors[0].field === 'proxyCheck') {
            errorMsg = errors[0].error;
          }
          notifyMessages(errorMsg, ALERT_ERROR);
          window.location.reload();
        }
      } else {
        if(requestUpdateStatus === SUCCESS) {
          if(pendingRequestCount === 1) {
            const message=intl.getI18nMessage(`label.application.details.section.${actionType}.all.success`);
            localStorage.setItem('notificationStatusRequestSaveSuccess', ALERT_SUCCESS);
            localStorage.setItem('notificationMessageRequestSaveSuccess', message);
            notifyMessages(message, ALERT_SUCCESS);
            window.location.reload();
          } else {
            setPendingRequestCount(pendingRequestCount - 1);
            window.location.reload();
          }
        } else if (requestUpdateStatus === FAIL){
          let errorMsg = intl.getI18nMessage(`label.application.details.section.${actionType}.error`);
          if(errors && errors.length > 0 && errors[0].field === 'proxyCheck') {
            errorMsg = errors[0].error;
          }
          notifyMessages(errorMsg, ALERT_ERROR);
        }
        setActionTableMap({
          ...actionTableMap,
          [actionTable]: {
            status: requestUpdateStatus,
            actionType: actionType,
          },
        });
      }
    }
  },[requestUpdateStatus]);
  useEffect(() => {
    if(appWithdrawStatus) {
      if(appWithdrawStatus === SUCCESS) {
        const message=intl.getI18nMessage(`label.application.details.section.withdraw.success`);
        notifyMessages(message, ALERT_SUCCESS);
        window.location.reload();
      } else if (appWithdrawStatus === FAIL){
        let errorMsg;
        if(errors && errors.length > 0) {
          errorMsg = errors[0].error;
        }
        errorMsg = errorMsg ? errorMsg : intl.getI18nMessage(`label.application.details.section.withdraw.error`);
        notifyMessages(errorMsg, ALERT_ERROR);
      }
    }
  },[appWithdrawStatus]);
  useEffect(() => {
    setShowActionAlert(false);
    if(get(appReviewResponse, 'hasErrors') && appReviewUpdateStatus === SUCCESS) {
      const message = get(appReviewResponse, 'action') === 'ACCEPT'
        ? intl.getI18nMessage(`label.applicaiton.details.section.accept.failed.notification.count`, { count : get(appReviewResponse, 'errorCount') }) :
        intl.getI18nMessage(`label.applicaiton.details.section.reject.failed.notification.count`, { count : get(appReviewResponse, 'errorCount') })
      notifyMessages(message, ALERT_ERROR);
      window.location.reload();
    } else if(appReviewUpdateStatus === SUCCESS) {
      notifyMessages(intl.getI18nMessage('label.application.details.section.accept.all.success'), ALERT_SUCCESS);
      window.location.reload();
    } else if(appReviewUpdateStatus === FAIL) {
      notifyMessages(intl.getI18nMessage(`label.application.details.section.${actionType}.all.error`), ALERT_ERROR, true);
      window.location.reload();
    }
  },[appReviewUpdateStatus]);
  const notifyMessages = (message, status, timeout) => {
    setNotificationStatus(status);
    localStorage.setItem('notificationStatus', status);
    setNotificationMessage(message);
    localStorage.setItem('notificationMessage', message);
    if(timeout) {
      setTimeout(() => {
        notifyMessages('', '');
      }, 3000);
    }
  };
  const reviewEntityRequest = (action) => {
    if(singleRequest) {
      setUuidType('REQUEST');
      setActionUuid(singleRequestUuid);
    } else {
      setUuidType('ENTITY');
      setActionUuid(entityUuid);
    }
    setActionType(action);
    setShowActionAlert(true);
  }
  const review = (uuidType, action, uuid, actionTable, reviewRequestType) => {
    setUuidType(uuidType);
    setActionType(action);
    setActionUuid(uuid);
    setActionTable(actionTable);
    setShowActionAlert(true);
    setReviewRequestType(reviewRequestType);
  };
  const submitReview = () => {
    if(uuidType === 'ENTITY' || reviewRequestType){
      props.reviewApplication(actionUuid, actionType, alertReason, reviewRequestType);
    } else {
      setReviewRequestType('');
      const payload = {
        isAccept: actionType === 'accept',
        requestId: actionUuid,
        reason: alertReason ? alertReason : '',
      }
      props.submitRequest(payload);
    }
  };

  const onWithdraw = (requestUuid) => {
    props.withdrawRequest(requestUuid)
  }

  const onAssignedOrgChange = (org = {}) => {
    if(!org) org = { uuid : '', name : '' }
    setAssignedOrg(org);
    setAssignedOrgSearchText(org.name);
  };

  const onClickTableValue = () => {
    reviewEntityRequest('accept')
  }

  const onAssignedRoleChange = (role) => setAssignedRole(role);
  const onShouldNotifyUserChange = () => setShouldNotifyUser(shouldNotifyUser => !shouldNotifyUser)
  const onAlertReasonChange = (reason) => setAlertReason(reason)

  const getAlertDialogInnerComponent = () => {
    return <AlertDialogInnerComponent
        classes={classes}
        requestType={requestType}
        isAcceptAction={actionType === 'accept'}
        getI18nMessage={getI18nMessage}
        assignedOrgSearchText={assignedOrgSearchText}
        assignedOrg={assignedOrg}
        onAssignedOrgChange={onAssignedOrgChange}
        assignedRole={assignedRole}
        onAssignedRoleChange={onAssignedRoleChange}
        assignRoleOptions={assignRoleOptions}
        shouldNotifyUser={shouldNotifyUser}
        onShouldNotifyUserChange={onShouldNotifyUserChange}
        alertReason={alertReason}
        onAlertReasonChange={onAlertReasonChange}
    />
  }

  const onAlertDialogClose = () => {
    setShouldNotifyUser(false);
    setShowActionAlert(false);
  }
  return (
    <Fragment>
      <div className={classes.content}
        id="request-details-page" data-apim-test="request-details-page"
      >
        {notificationMessage &&
          <AlertMessages
            id="app-details-notification"
            variant={notificationStatus}
            message={notificationMessage}
            containerClass={classes.notificationWidthClass}
            onClose={() => { notifyMessages('', ''); }}
          />
        }
        {!hasRequests &&
          <div className={classes.noResults}>
            {intl.getI18nMessage('label.request.no.results')}
          </div>
        }
        <AlertDialog
          id="request-detail-accept-reject-dialog"
          data-apim-test="request-detail-accept-reject-dialog"
          isOpen={showActionAlert}
          title={intl.getI18nMessage(`label.request.list.actions.alert.${actionType}.title`)}
          description={intl.getI18nMessage('label.request.list.actions.alert.description')}
          disableSubmit={actionType === 'reject' && (!alertReason || !alertReason.trim())}
          submitText={intl.getI18nMessage(`label.request.list.actions.${actionType}`)}
          cancelText={intl.getI18nMessage('label.cancel.button')}
          component={showActionAlert && getAlertDialogInnerComponent()}
          onClose={onAlertDialogClose}
          onSubmit={() => submitReview()}
          onCancel={onAlertDialogClose}
          submitButtonClass={actionType === 'accept' ? '' : classes.rejectSubmitButton}
        />
        <div className={classes.header}>
          <div className={classes.sectionHead}>
            { ((singleRequest || pendingRequestCount > 0) && isAdmin) &&
              <div className={classes.pageButtonDiv}>
                <Button
                  id="accept-button"
                  data-apim-test="accept-button"
                  variant="contained"
                  color="secondary"
                  className={classes.acceptButton}
                  onClick={() => reviewEntityRequest('accept')}
                >
                  {intl.getI18nMessage(`label.application.details.section.accept.${singleRequest? '' : 'all.'}button`)}
                </Button>
                <Button
                  id="reject-button"
                  data-apim-test="reject-button"
                  className={classes.rejectButton}
                  onClick={() => reviewEntityRequest('reject')}
                  >
                  {intl.getI18nMessage(`label.application.details.section.reject.${singleRequest? '' : 'all.'}button`)}
                </Button>
              </div>
            }
          </div>
        </div>
        {orderList.filter(type => Object.keys(requestDetailsMap).includes(type)).map(key => {
           if(includes(['apiplans', 'apis'], key) && requestDetailsMap[key].length > 0 &&
            (get(requestDetailsMap[key][0], 'requestType') === 'PATCH_APPLICATION_APIS'
              || get(requestDetailsMap[key][0], 'requestType') === 'PATCH_APPLICATION_API_PLANS')) {
            return(
              <ApisTable
                key={key}
                sectionType={key}
                columns={getTableApisColumns(classes, singleRequest && requestType !== 'APPLICATION_UPDATE', key, isAdmin)}
                rows={requestDetailsMap[key]}
                onReview={review}
                classes={classes}
                user={props.user}
                entityUuid={entityUuid}
                apisRequestDetails={apisRequestDetails}
                isAdmin={isAdmin}
                onWithdraw={onWithdraw}
              />
            )
           } else {
            return(
              <RequestSectionTable
                key={key}
                sectionType={key}
                columns={getTableColumns(classes, singleRequest && requestType !== 'APPLICATION_UPDATE', key, onClickTableValue, isAdmin)}
                rows={requestDetailsMap[key]}
                requestInfo={requestInfoMap[key]}
                actionStatus={actionTableMap[key]}
                onReview={review}
                classes={classes}
                user={props.user}
                isAdmin={isAdmin}
                onWithdraw={onWithdraw}
              />
            )
           }
        })}
        <Footer />
      </div>
    </Fragment>
  );
};

export const AlertDialogInnerComponent = (props) => {
    const {
      classes,
      isAcceptAction,
      getI18nMessage,
      alertReason,
      onAlertReasonChange,
    } = props;
  return (
    <div>
      <FormTextField
        fieldContainerClass={classes.alertMessageContainerClass}
        maxLength={1000}
        multiline
        handleChange={(value) => onAlertReasonChange(value)}
        placeholder={getI18nMessage(`label.request.list.actions.alert.${isAcceptAction ? 'accept' : 'reject'}.placeholder`)}
        rows={4}
        textFieldClass={classes.alertMessageClass}
        value={alertReason}
      />
      <div className={classes.alertMessageMaxLengthWarningClass}>
        {getI18nMessage('label.request.list.actions.alert.max.length.warning')}
      </div>
    </div>
  );
};

AlertDialogInnerComponent.propTypes = {
  classes : object,
  onAssignedRoleChange : func,
  assignRoleOptions : array,
  shouldNotifyUser : bool,
  onShouldNotifyUserChange : func,
  alertReason : string,
  onAlertReasonChange : func,
  getI18nMessage: func,
  isAcceptAction: bool,
}

const mapStateToProps = state => ({
  listResults: getDetailsListResults(state),
  requestDetails: getRequestDetails(state),
  requestUpdateStatus: getRequestUpdateStatus(state),
  appReviewUpdateStatus: getAppReviewUpdateStatus(state),
  user: getUserDetails(state),
  errors: getErrors(state),
  apiPlansEnabled: getFeatureFlagApiPlans(state),
  appReviewResponse: getAppReviewResponse(state),
  appWithdrawStatus: getAppWithdrawStatus(state),
});

const mapDispatchToProps = {
  fetchListDetails,
  fetchRequestDetails,
  submitRequest,
  reviewApplication,
  withdrawRequest,
  push,
};

Requests.propTypes = {
  fetchListDetails: func,
  requestDetails: object,
  fetchRequestDetails: func,
  listResults: arrayOf(object),
  getListResults: func,
  classes: object,
  requestUpdateStatus: string,
  appReviewUpdateStatus: string,
  submitRequest: func,
  reviewApplication: func,
  push: func,
  user: object,
  errors: arrayOf(object),
  applicationUuid: string,
  apiPlansEnabled: bool,
  appReviewResponse: object,
  isAdmin: bool,
  isCurrentTab: bool,
  appWithdrawStatus: string,
  withdrawRequest: func,
};


export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(Requests);
